module.exports = __webpack_public_path__ + "static/media/baseline-arrow_drop_down-24px.c5891eb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Comp/img/baseline-arrow_drop_down-24px.svg
// module id = 94
// module chunks = 0